import { useUBLContext, ZigzagEvent } from '@common/log-manager';

export const useGalleryUBL = () => {
  const ublContext = useUBLContext();

  const impressionMainImageUBL = (catalog_product_id: string, image_id: string, image_idx: number) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      object_id: image_id,
      object_idx: image_idx,
      object_section: 'main_image',
      object_type: 'image',
      data: JSON.stringify({ original_product_id: catalog_product_id }),
    });
  };
  return {
    impressionMainImageUBL,
  };
};
